export default {
  elements: [
    // {
    //   type: "text",
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    //   properties: {
    //     label: "Name",
    //     placeholder: "Enter your Full Name here...",
    //     required: true,
    //   },
    // },
    // {
    //   type: "email",
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    //   properties: {
    //     label: "Email",
    //     placeholder: "Enter your Email here...",
    //     required: true,
    //   },
    // },
    // {
    //   type: "text",
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    //   properties: {
    //     label: "Phone Number",
    //     placeholder: "Enter your Phone Number here...",
    //     required: true,
    //   },
    // },
    // {
    //   type: "text",
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    //   properties: {
    //     label: "Alternate Phone Number",
    //     placeholder: "Enter your Alternate Phone Number here...",
    //     //required: true,
    //   },
    // },
    // {
    //   type: "date",
    //   properties: {
    //     label: "Date of Birth",
    //     placeholder: "Enter Date Element here...",
    //     required: true,
    //   },
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    // },
    // {
    //   type: "select",
    //   properties: {
    //     label: "Gender",
    //     options: ["Male", "Female"],
    //     required: true,
    //   },
    //   multiple: false,
    //   required: false,
    //   fillableByCandidate: true,
    //   fillableByHR: true,
    // },
    // {
    //   type: "textarea",
    //   properties: {
    //     label: "Address",
    //     placeholder: "Enter Address here...",
    //     required: true,
    //   },
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    // },
    // {
    //   type: "select",
    //   properties: {
    //     label: "State",
    //     options: [
    //       "Andhra Pradesh",
    //       "Arunachal Pradesh",
    //       "Assam",
    //       "Bihar",
    //       "Chhattisgarh",
    //       "Goa",
    //       "Gujarat",
    //       "Haryana",
    //       "Himachal Pradesh",
    //       "Jharkhan",
    //       "Karnataka",
    //       "Kerala",
    //       "Madhya Pradesh",
    //       "Maharasthra",
    //       "Manipur",
    //       "Meghalaya",
    //       "Mizoram",
    //       "Nagaland",
    //       "Odisha",
    //       "Punjab",
    //       "Rajasthan",
    //       "Sikkim",
    //       "Tamil Nadu",
    //       "Telangana",
    //       "Tripura",
    //       "Uttar Pradesh",
    //       "Uttarakhand",
    //       "West Bengal",
    //     ],
    //     required: true,
    //   },
    //   multiple: false,
    //   required: false,
    //   fillableByCandidate: true,
    //   fillableByHR: true,
    // },
    // // {
    // //   type: "text",
    // //   properties: {
    // //     label: "Highest Qualification",
    // //     placeholder: "Enter Highest Qualification here...",
    // //     required: true,
    // //   },
    // //   fillableByCandidate: true,
    // //   fillableByHR: false,
    // // },
    // {
    //   type: "select",
    //   properties: {
    //     label: "Highest Qualification",
    //     options: ["10th", "12th", "Graduation", "Post Graduation"],
    //     required: true,
    //   },
    //   multiple: false,
    //   required: false,
    //   fillableByCandidate: true,
    //   fillableByHR: true,
    // },
    // {
    //   type: "text",
    //   properties: {
    //     label: "Indian Languages",
    //     placeholder:
    //       "Enter all the indian languages here. Use comma to separate multiple values.",
    //     required: true,
    //   },
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    // },
    // // {
    // //   type: "text",
    // //   properties: {
    // //     label: "How did you come to know about us?",
    // //     placeholder: "",
    // //     required: true,
    // //   },
    // //   fillableByCandidate: true,
    // //   fillableByHR: false,
    // // },
    // // {
    // //   type: "text",
    // //   properties: {
    // //     label: "Any specific experience do you have?",
    // //     placeholder: "",
    // //     required: true,
    // //   },
    // //   fillableByCandidate: true,
    // //   fillableByHR: false,
    // // },
    // {
    //   type: "select",
    //   properties: {
    //     label: "Any specific experience do you have?",
    //     options: [
    //       "Sales",
    //       "Content Writer",
    //       "Back Office",
    //       "BPO",
    //       "Hotel Management",
    //       "Technical Field",
    //       "Others",
    //     ],
    //     required: true,
    //   },
    //   multiple: false,
    //   required: false,
    //   fillableByCandidate: true,
    //   fillableByHR: true,
    // },
    // // {
    // //   type: "text",
    // //   properties: {
    // //     label: "How did you come to know about us?",
    // //     placeholder: "",
    // //     required: true,
    // //   },
    // //   fillableByCandidate: true,
    // //   fillableByHR: false,
    // // },
    // {
    //   type: "select",
    //   properties: {
    //     label: "How did you come to know about us?",
    //     options: [
    //       "Social Media",
    //       "Facebook",
    //       "Maxicus Website",
    //       "SMS",
    //       "Job Portal",
    //       "Consultant",
    //       "Employee Reference",
    //       "Walkin",
    //       "Linkedln",
    //     ],
    //     required: true,
    //   },
    //   multiple: false,
    //   required: false,
    //   fillableByCandidate: true,
    //   fillableByHR: true,
    // },
    // {
    //   type: "text",
    //   properties: {
    //     label:
    //       "If employee reference, ( Mention Employee name and employee id )",
    //     placeholder: "",
    //     // required: true,
    //   },
    //   fillableByCandidate: true,
    //   fillableByHR: false,
    // },
  ],
};
